import { glossary, watchGuide } from '@/mocks/homeData';

export default function WatchGuide() {
  return (
    <section id="guide" className="w-full scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            Guide
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            观看与检索指南：四步找到合适的版本
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从确定版本方向，到对照分集状态、统一译名、再到用检索定位台词，
            按这个顺序走一遍，基本不会再被版本问题打断观看节奏。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <ol className="lg:col-span-2 space-y-4">
            {watchGuide.map((item) => (
              <li
                key={item.step}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50">
                  {item.step}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-950">字幕小词典</h3>
            </div>
            <dl className="mt-5 space-y-4">
              {glossary.map((item) => (
                <div key={item.term} className="border-b border-background-200 pb-4 last:border-0 last:pb-0">
                  <dt className="font-label text-sm font-medium text-foreground-900">{item.term}</dt>
                  <dd className="mt-1 text-sm leading-relaxed text-foreground-600">{item.meaning}</dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </div>
    </section>
  );
}